export const parentDocumentTypePatcher = (data) => {
    return {
        __typename: 'ParentDocument',
        ...data,
        documentId: data.permissionId,
    };
};
